// window.addEventListener('load', function() {
//   alert('Monochromas load')
// })
// document.addEventListener('load', function() {
//   alert('Monochromas doc load')
// })
// document.addEventListener('DOMContentLoaded', function() {
//   alert('Monochromas DOMContentLoaded')
// })
// document.fonts.ready.then(function() {
//   alert('Monochromas fonts')
// })
// document.onload.then(function() {
//   alert('Monochromas doc onload')
// })
// window.onload.then(function() {
//   alert('Monochromas win onload')
// })
export { Neigalieji }

function Neigalieji() {
  // alert('Neigalieji!')

  Monochromas()
}

//############################################################
//############################################################
function Monochromas() {
  // alert('Monochromas!')

  //document.getElementById("blk_neigal").innerHTML="Ų¤Ā®prasta&nbsp;versija";
  // JIRA WEB-3317 document.body.classList.add("neigal");

  var o,
    len,
    i,
    newColor = 'rgb(0, 0, 0)'
  o = document.querySelectorAll('p,span,div')
  len = o !== null ? o.length : 0
  //alert("len=" + len);
  for (i = 0; i < len; i++) {
    o[i].style.color = newColor
  }
  var cn, cplus
  o = document.querySelectorAll('a')
  len = o !== null ? o.length : 0
  //alert("len.a=" + len);
  for (i = 0; i < len; i++) {
    if (o[i].id == 'chat_href') {
      continue
    } // isimtis chat_href'ui, KAD JIS NEPRADINGTU
    o[i].classList.add('neigal')
  }

  var elems = document.body.getElementsByTagName('*')
  Array.prototype.forEach.call(elems, function(elem) {
    var borderColor = getValue(elem, 'border-color'),
      bgColor = getValue(elem, 'background-color'),
      color = getValue(elem, 'color'),
      img = getValue(elem, 'background-image')

    //        if( bgColor ){ elem.style.backgroundColor = "rgb(255,255,255)"; }
    if (borderColor) {
      elem.style.borderColor = newColor
    }
    if (color) {
      elem.style.color = newColor
    }
    if (img) {
      elem.classList.add('neigal')
    }
  })

  // JIRA WEB-3317: verciames taip...
  o = document.querySelectorAll('img,input,table')
  len = o !== null ? o.length : 0
  for (i = 0; i < len; i++) {
    o[i].classList.add('neigal')
  }

  o = document.getElementById('u5')
  if (o) {
    o.classList.add('neigal')
  }

  // document.getElementById('neigal_grizti').style = 'display: block'
}

function getValue(elem, property) {
  return window.getComputedStyle(elem, null).getPropertyValue(property)
}
